export default class MenuEntryType {
    /**
     * @param {string} name
     * @param {string} label
     * @param {number[]|null} allowedOnMenu
     * @param {string[]|null} allowedChildren
     * @param {boolean|null} choosable
     * @param {string[]|null} allowedParents
     * @param {object|null} configComponent
     */
    constructor(name, label, allowedOnMenu, allowedChildren, choosable = true, allowedParents = null, configComponent = null) {
        this.name = name;
        this.label = label;
        this.allowedOnMenu = allowedOnMenu;
        this.allowedChildren = allowedChildren || null;
        this.choosable = choosable === undefined ? true : choosable;
        this.allowedParents = allowedParents || null;
        this.configComponent = configComponent;
    }

    /**
     * @return {boolean}
     */
    canHaveChildren() {
        return this.allowedChildren === null || this.allowedChildren.length > 0;
    }

    /**
     * @param {string} menuEntryType
     * @return {boolean}
     */
    isChildrenAllowed(menuEntryType) {
        if (this.allowedChildren === null) {
            return true;
        }

        return this.allowedChildren.indexOf(menuEntryType) !== -1;
    }

    /**
     * @param {string} parentMenuEntryType
     * @return {boolean}
     */
    isAllowedOnParent(parentMenuEntryType) {
        if (this.allowedParents === null) {
            return true;
        }

        return this.allowedParents.indexOf(parentMenuEntryType) !== -1;
    }
}



// WEBPACK FOOTER //
// ./routes/app/domain/menu/MenuEntryType.js